import React from 'react';
import { FaMoneyBillWave, FaCheckCircle, FaChartLine, FaClock, FaGlobe, FaDumbbell } from 'react-icons/fa'; // Importa los iconos que prefieras
import './Benefits.css';

const Benefits = () => {
  const benefits = [
    { title: "Oportunidades abundantes", icon: <FaCheckCircle /> },
    { title: "Desarrollo profesional", icon: <FaChartLine /> },
    { title: "Libertad horaria", icon: <FaClock /> },
    { title: "Libertad geográfica", icon: <FaGlobe /> },
    { title: "Desarrollo personal", icon: <FaDumbbell /> }
  ];

  return (
    <section className="benefits">
      {benefits.map((benefit, index) => (
        <div key={index} className="benefit-card">
          <span className="icon">{benefit.icon}</span>
          <h3>{benefit.title}</h3>
        </div>
      ))}
    </section>
  );
};

export default Benefits;
